import * as React from "react";

import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CloseableDialogTitle from "../common/CloseableDialogTitle";
import { LacrosseVariant, useSelectedSport } from "../common/context/sport";

import useDialog from "./useDialog";

const TITLE = "Which lacrosse do you play?";

/**
 * Men's and women's lacrosse are marked out differently. This choice is
 * presentation only - the ball, the throwing envelope and the physics are the
 * same either way, so it never leaves the browser.
 *
 * The field art is not ready yet, so both options currently draw the same
 * placeholder court. The copy says so rather than implying a difference that
 * is not there.
 */
export default function LacrosseVariantDialog(): React.JSX.Element {
    const { setDialogType } = useDialog();
    const { lacrosseVariant, updateLacrosseVariant } = useSelectedSport();

    return (
        <>
            <CloseableDialogTitle onClose={() => setDialogType(null)}>
                {TITLE}
            </CloseableDialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <RadioGroup
                        aria-label="Lacrosse variant"
                        value={lacrosseVariant}
                        onChange={(e) =>
                            updateLacrosseVariant(
                                e.target.value as LacrosseVariant,
                            )
                        }
                    >
                        <FormControlLabel
                            value="MENS"
                            control={<Radio />}
                            label="Men's"
                        />
                        <FormControlLabel
                            value="WOMENS"
                            control={<Radio />}
                            label="Women's"
                        />
                    </RadioGroup>
                    <Typography variant="body2" color="text.secondary">
                        We use this to draw the right field markings. Your
                        choice is saved now, but the field graphics are still
                        being built, so both options look the same for the
                        moment.
                    </Typography>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={() => setDialogType(null)}>
                    Done
                </Button>
            </DialogActions>
        </>
    );
}
